import { SiteModel } from "@/models/site.model";
import { calculateTotalVolume } from "@/services/site.service";
import { Validators } from "@/services/validators.service";
import store from "@/store";
import {
  SEND_JSON_STATISTICS,
  UPDATE_CONDITIONS_ACCEPTED,
  UPDATE_SITE_MODEL,
} from "@/store/operators";
import { computed, ComputedRef, reactive, ref } from "@vue/composition-api";
import { useVuelidate, Validation } from "@vuelidate/core";
import { maxValue, required } from "@vuelidate/validators";
import { Component, Prop, Vue } from "vue-property-decorator";
import ElementaryZones from "./parts/ElementaryZones/index.vue";
import TermsOfUse from "@/components/TermsOfUseModal/index.vue";
import { abacaEvent, getEventJsonData } from "@/services/statistics.service";

@Component({
  components: { ElementaryZones, TermsOfUse },
  setup() {
    const site: ComputedRef<SiteModel> = computed(() => store.state.siteModule.site);
    const maxTotalVolume: number = store.state.globalAppDataModule.settings.maxTotalVolume;
    const totalVolume = computed(() => calculateTotalVolume(site.value.elementaryZones));

    const validation = {
      site: {
        title: {
          required,
        },
        elementaryZones: {
          required,
          hasPersonnelDecontamination: Validators.hasPersonnelDecontamination,
          /*rendre non requis l'instance de deconta des déchets dans la partie 1
           hasWasteDecontamination: Validators.hasWasteDecontamination,*/
          hasExtractors: Validators.hasExtractors,
          namesAreUnique: Validators.elementaryZonesHaveUniqueNames,
        },
      },
      totalVolume: {
        maxValue: maxValue(maxTotalVolume),
      },
    };
    const v = useVuelidate(validation, reactive({ site: site, totalVolume: totalVolume }));
    return { v: v, site: ref(site), totalVolume: totalVolume };
  },
})
export default class SiteComponent extends Vue {
  @Prop() bus!: Vue;
  site!: SiteModel;
  totalVolume!: number;
  cleanAdvice = this.$sanitize(this.$t("components.sitePage.advice").toString());
  v!: Validation;

  // get number of elementaryZones
  get numberOfElementaryZones(): number {
    return this.site.elementaryZones.length;
  }

  // get the boolean that indicate if the user has already valided the terms of use modal.
  get conditionsValided(): boolean {
    return store.state.globalAppDataModule.conditions_accepted;
  }

  tooltipAreasToConfined = this.$sanitize(this.$t("help.sitePage.areasToConfined").toString());

  mounted(): void {
    if (!this.conditionsValided) {
      this.showTermsOfUseModale();
    }
    this.bus.$on("validate", this.validate.bind(this));
    store.dispatch(SEND_JSON_STATISTICS, getEventJsonData(abacaEvent.ECRAN_CHANTIER));
  }

  // unsubrcribe all event on destroy
  destroyed(): void {
    this.bus.$off();
  }

  // validate step and send it to store
  validate(): void {
    let siteModel = Object.assign({}, this.site);
    siteModel= this.deleteZoneWasteDecontaminationFalse(siteModel)
    siteModel.totalVolume = this.totalVolume;
    store.commit(UPDATE_SITE_MODEL, siteModel);
  }
 
  //Delete the equipment waste if wasteDecontamination == no
  deleteZoneWasteDecontaminationFalse(site:SiteModel): SiteModel {
    for (let i = 0; i < site.elementaryZones.length; i++) {
      const element = site.elementaryZones[i];
      if(element.wasteDecontamination == false && element.wasteEquipment) {
        delete element.wasteEquipment;
      }
    }
    return site;
  }
  /**
   * Show TermsOfUse modal
   */
  showTermsOfUseModale(): void {
    this.$bvModal.show(`termsOfUseId`);
  }

  /**
   * Hide TermsOfUse modal
   */
  onTermsOfUseClose(): void {
    this.$bvModal.hide(`termsOfUseId`);
    store.commit(UPDATE_CONDITIONS_ACCEPTED, true);
  }
}
